/*
	This just renders a basic table of Creatives with their name, ID, and formatted approval status.

	It takes an array, `creatives` and an optional `shouldLinkPreview` prop, which defaults to true.

	If `shouldLinkPreview` is true, the Creative name will link to a new tab to the appropriate
	Creative Preview app, depending on the adType.
*/

import React from "react";
import PropTypes from "prop-types";
import { TextOverflow, creativePreviewURL } from "utils/common";
import StatusColumn from 'widgets/grid/cells/StatusColumn';

import "./CreativesTable.css";

export default function CreativesTable(props){
	const { creatives, shouldLinkPreview, className, shouldShowStatus } = props;
	const rows = creatives.map((creative) => {
		const { name, id, approval } = creative || {};
		let nameContent = <TextOverflow value={name} />;
		if(shouldLinkPreview){
			nameContent = <a target="_blank" href={creativePreviewURL(creative)}>{nameContent}</a>;
		}

		return (
			<tr key={id}>
				<td className="creative-name-column">
					{nameContent}
				</td>
				<td className="creative-id-column">{id}</td>
				{ shouldShowStatus && <td className="creative-status-column"><StatusColumn value={approval} shouldShowLinks={false} /></td> }
			</tr>
		);
	});

	return (
		<table className={`creatives-table basic-table ${className}`}>
			<thead>
				<tr>
					<th className="creative-name-column">Creative Name</th>
					<th className="creative-id-column">ID</th>
					{ shouldShowStatus && <th className="creative-status-column">Status</th> }
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

CreativesTable.displayName = "CreativesTable";

CreativesTable.propTypes = {
	creatives: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]),
		name: PropTypes.string,
		adType: PropTypes.string, // We need the adType to know what Preview URL to use
	})),
	shouldLinkPreview: PropTypes.bool,
	shouldShowStatus: PropTypes.bool,
	className: PropTypes.string,
};

CreativesTable.defaultProps = {
	creatives: [],
	shouldLinkPreview: true,
	shouldShowStatus: true,
	className: "",
};
